(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let nextId = 0;

  function initialize(root) {
    const containers = [...root.querySelectorAll('.scrolling-text-container')];
    if (root.matches?.('.scrolling-text-container')) containers.unshift(root);
    containers.forEach(container => {
      if (container.dataset.marqueeControls) return;
      const track = container.querySelector('.scrolling-text-inner');
      if (!track) return;
      container.dataset.marqueeControls = 'true';
      track.removeAttribute('role');
      track.setAttribute('aria-live', 'off');
      if (!track.id) track.id = `accessible-marquee-${++nextId}`;

      // Repeated visual copies should not repeat the same message to screen readers.
      const seen = new Set();
      [...track.children].forEach(group => {
        const text = group.textContent.replace(/\s+/g, ' ').trim();
        if (seen.has(text)) {
          group.setAttribute('aria-hidden', 'true');
          group.setAttribute('inert', '');
          group.dataset.marqueeDuplicate = 'true';
        } else {
          seen.add(text);
        }
      });

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'marquee-motion-toggle';
      button.setAttribute('aria-controls', track.id);
      let paused = reducedMotion.matches;
      function update() {
        container.dataset.marqueePaused = String(paused);
        const label = paused ? 'Resume scrolling' : 'Pause scrolling';
        button.setAttribute('aria-label', label);
        button.title = label;
      }
      button.addEventListener('click', () => {
        paused = !paused;
        update();
      });
      container.addEventListener('focusin', event => {
        if (event.target.matches(':focus-visible')) {
          paused = true;
          update();
        }
      });
      container.append(button);
      update();
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  reducedMotion.addEventListener('change', event => {
    if (!event.matches) return;
    document.querySelectorAll('[data-marquee-controls]').forEach(container => {
      const button = container.querySelector('.marquee-motion-toggle');
      if (container.dataset.marqueePaused !== 'true') button.click();
    });
  });
})();
